import { getRelationList, getDoctorList, batchTransferForStore, memberSearch, listProcessingByMember, typeConfigList } from "@/api/system/doctorManage";
import {deepClone} from '@/utils'
export default {
  components: {},
  props: {
    open: {
      type: Boolean,
      default() {
        return false
      }
    },
    storeList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      queryForm: {
        memberName: ''
      },
      typeConfigList: [],
      innerTableData: [],
      dropdownName: '',
      doctorList: [],
      healthList: [],
      dieticianList: [],
      relationList: [],
      multipleSelectionInner: [],
      multipleSelection: [],
      innerVisible: false,
      total: 0,
      totalInside: 0,
      queryParamsInside: {
        pageNum: 1,
        pageSize: 10
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      active: 1,
      ruleForm: {
        storeIds: [],
        updateManagerFlag: false,
        doctorId: undefined,
        healthId: undefined,
        dieticianId: undefined
      },
      rules: {
        storeIds: [
          { required: true, message: "请选择门店", trigger: "change" }],
        updateManagerFlag: [
        { required: true, message: "请选择是否更新", trigger: "change" }],
      },
      insideMemberId: undefined
    };
  },
  computed: {
    dropdownList: {
      get() {
        return this.storeList
      },
      set(val) {
      }
    }
  },
  watch: {
    open(val) {
      if(!val) {
        this.resetForm('ruleForm')
        this.restoreDefault()
      }
    },
    innerVisible(val) {
      if(!val) {

      }
    }
  },
  methods: {
    /**会员搜索 */
    handleQuery() {
      this.handleMemberSearch()
    },
    /**格式化状态码 */
    formatStatus(type) {
      return {
        1: "未开始",
        2: "跟进中",
        3: "已处理",
        4: "待评价",
        5: "已完结"
      }[type];
    },
    /**获取工单步骤表 */
    getOperationSteps(type) {
    const obj = this.typeConfigList.find(item => {
      return item.id === type
    })
    if(obj) {
      return obj
    }else {
      return {}
    }
  },
    /**
     * 工单类型配置枚举获取
     */
    handleTypeConfigList() {
      typeConfigList().then(res => {
        if(res.code === 200) {
          this.typeConfigList = res.data || []
        }
      })
    },
    /** */
    handleDropdowmCommand(command) {
      // console.log('command===>',command);
      const obj = this.dropdownList.find(item => {
        return item.id === command
      })
      this.dropdownName = obj ? obj.storeName : ''
      this.handleMemberSearch(command)
    },
    /**
     * 筛选门店下会员
     */
     handleMemberSearch(id=this.dropdownList[0].id) {
       const data = {
         pageSize: 1000,
         pageNum: 1,
         storeId: id,
         memberName: this.queryForm.memberName
       }
      return new Promise((resolve, reject) => {
        memberSearch(data).then(res => {
          this.tableData = res.data.records || []
          this.total = res.data.total || 0
          resolve()
        })
      })
     },
    /**
     * 根据不同的类型获取对应的医生列表
     */
    handleGetListByType() {
      // 1：专属医生，2：健康管理师，3：营养师 4：药师
      for (let i = 1; i < 4; i++) {
        this.handleGetDoctorList(i).then(res => {
          const obj = {1: 'doctorList', 2: 'healthList', 3: 'dieticianList'}
          this[obj[i]] = res.data.records
        })
      }
    },
    /**
     * 获取医护人员列表
     */
    handleGetDoctorList(type) {
      const data = {
        pageNum: 1,
        pageSize: 1000,
        healthManagerType: type
      }
      return new Promise((reslove, reject) => {
        getDoctorList(data).then(res => {
         reslove(res)
        })
      })
    },
    /**
     * 获取门店列表
     */
    handleGetRelationList() {
      const data = {pageNum: 1, pageSize: 100}
      getRelationList(data).then((res) => {
        if (res.code == 200) {
          this.relationList = res.data.records || [];
        }
      })
    },
    /**
     * 内部弹框关闭钩子
     */
     innerBeforeClose(done) {
       done()
      // this.multipleSelectionInner = []
     },
    /**
     * 内部列表的多选框事件
     */
     handleSelectionInnerChange(val) {
      this.multipleSelectionInner = val.map(item => {
        return item.id
      })
     },
    /**
     * 确认选择的工单
     */
     handleConfirm() {
      this.innerVisible = false
     },
     /**取消选择工单 */
     handleCancel() {
      // this.multipleSelectionInner = []
      this.innerVisible = false
     },
     /**
      * 获取选取的健康管理师类型
      */
     getHealthType() {
      let arr = []
      const {doctorId, healthId, dieticianId } = this.ruleForm
      if(doctorId) {
        arr.push(1)
      }
      if(healthId) {
        arr.push(2)
      }
      if(dieticianId) {
        arr.push(3)
      }
      return arr.join(',')
     },
    /**
     * 获取内部列表
     */
     getListInside() {
      // this.totalInside = 10
      const data = {
        memberId: this.insideMemberId,
        healthManagerType: this.getHealthType(),
        pageNum: this.queryParamsInside.pageNum,
        pageSize: this.queryParamsInside.pageSize
      }
      listProcessingByMember(data).then(res => {
        this.innerTableData = res.data || []
        this.totalInside = res.data.total || 0
        this.$nextTick(_=>{
        })
      })
     },
    /**
     * 获取列表
     */
     getList() {
      this.total = 10
     },
    /**
     * 会员列表 勾选框
     * @param {*} row 
     */
     handleSelectionChange(val) {
      this.multipleSelection = val
    },
    /**
     * 点击工单按钮
     */
     handleClick(row) {
      this.innerVisible = true
      this.handleTypeConfigList()
      this.insideMemberId = row.id
      this.getListInside()
    },
    /**
     *上一步
     */
     handleBack() {
      if(this.active-- < 2) {
        this.active = 1
      }
     },
    /**
     * 下一步
     */
    handleNext() {
      // 校验第二步是否填写
      if(this.active === 1) {
        if(!this.handleValidateField(['healthId','doctorId','dieticianId','delivery'])) {
          return false
        }
        const {healthId,doctorId,dieticianId} = this.ruleForm
        if(!healthId && !doctorId && !dieticianId) {
          this.$message.error('至少选择一个!')
          return false
        }
      }
      if(this.active++ > 1) {
        this.active = 1
      }
      if(this.active === 2) {
        // 到该步骤的时候 获取选择门店列表
        this.dropdownList = this.handleGetCheckStoreList()
        this.dropdownName = this.dropdownList[0]?.storeName
        this.storeId = this.dropdownList[0].id
        this.handleMemberSearch()
      }
    },
    /**
     * 对某个字段进行校验
     * @param {String} props 字段名称
     * @returns 是否通过校验
     */
    handleValidateField(props) {
      let flag = null
      this.$refs.ruleForm.validateField(props, errMessage => {
        if (errMessage) {
          flag = false
        } else {
          flag = true
          return false;
        }
      })
      return flag
    },
    /**
     * 获取选择的门店列表
     */
    handleGetCheckStoreList() {
      return this.relationList.filter(item => {
        return this.ruleForm.storeIds.includes(item.id)
      })
    },
    /**
     * 处理map数据
     */
    formatMapData(data) {
      let workOrderIds = []
      let memberIds = []
      for(let [key, value] of data) {
        memberIds.push(key)
        value && workOrderIds.push(value)
      }
      return {
        workOrderIds: workOrderIds.join(','),
        memberIds: memberIds.join(',')
      }
    },
    /**提交 */
    submitForm(formName) {
      const {healthId,doctorId,dieticianId} = this.ruleForm
      if(!healthId && !doctorId && !dieticianId) {
        this.$message.error('至少选择一个!')
        return false
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          const data = deepClone(this.ruleForm)
          data.memberIds = this.multipleSelection.map(item => item.id).join(',')
          data.workOrderIds = this.multipleSelectionInner.join(',')
          data.storeIds = this.dropdownList.map(item=>item.id).join(',')
          batchTransferForStore(data).then(res => {
            this.$message.success('转移成功')
            this.$emit('success')
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**重置表单 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**恢复组件默认值 */
    restoreDefault() {
      this.active = 1
      this.multipleSelectionInner = []
      this.multipleSelection = []
      this.$refs?.multipleTableInner?.clearSelection()
      this.$refs?.multipleTable?.clearSelection()
    }
  },
  created() {
    if(this.active === 1) {
      this.handleGetListByType()
    }
    this.handleGetRelationList()
  },
  mounted() {}
};